import { render } from "./FacilityServicesTab.vue?vue&type=template&id=1c20ae92&scoped=true"
import script from "./FacilityServicesTab.vue?vue&type=script&lang=js"
export * from "./FacilityServicesTab.vue?vue&type=script&lang=js"

import "./FacilityServicesTab.vue?vue&type=style&index=0&id=1c20ae92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c20ae92"]])

export default __exports__